import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = ["placeholder", "value", "type", "name", "required", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_FormErrors = _resolveComponent("FormErrors")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group js-form-validation__group", {'has-error': _ctx.errors.length}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "icon"),
        _createVNode(_component_FormLabel, {
          label: _ctx.label,
          id: _ctx.id,
          required: _ctx.required
        }, null, 8, ["label", "id", "required"]),
        _createElementVNode("input", {
          class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors.length}]),
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
          placeholder: _ctx.placeholder,
          value: _ctx.value,
          type: _ctx.type,
          name: _ctx.name,
          required: _ctx.required,
          id: _ctx.id
        }, null, 42, _hoisted_3)
      ])
    ]),
    _createVNode(_component_FormErrors, { errors: _ctx.errors }, null, 8, ["errors"])
  ], 2))
}